








import Vue from "vue";
import Moment from "moment";

export default Vue.extend({
  props: {
    day: {
      type: Number,
      required: true
    },
    weather: {
      type: String,
      required: true
    },
    min: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    weathers: {
      clear: "sunny",
      clouds: "cloudy",
      rain: "rainy",
      thunderstorm: "flash",
      snow: "snow",
      drizzle: "rainy"
    } as Record<string, string>
  }),

  computed: {
    icon(): string {
      return this.weathers[this.weather];
    },

    humanDay(): string {
      return Moment()
        .add(this.day, "days")
        .format("dddd");
    }
  }
});
